export default function (app) {
    app.directive('ktsRightsStreamingReport', function () {

                    
        return {
            template: require('./rightsStreamingReport.html'),
            controller: ['$scope', 'Restangular','Auth', function Controller($scope, Restangular, Auth) {
                    $scope.$watch('date',function(){ 
                        
                        
                        var current = $scope.date;
                        
                        if (current.getMonth() === 11) {
                            var next = new Date(current.getFullYear() + 1, 0, 1);
                        } else {
                            var next = new Date(current.getFullYear(), current.getMonth() + 1, 1);
                        }
                        
                        //because of daylight saving time
                        current.setHours(12); 
                        next.setHours(12);
                        
                        var c = current.toISOString().slice(0,10);
                        var n = next.toISOString().slice(0,10);
                                                
                        if (window.location.hostname.indexOf('lvarela') !== -1) {
                            var root = 'http://api.kts.lvarela.com';
                        } else {
                            var root = 'https://api.karaoke2sing.com';
                        }
        
                        
                        $scope.url = root + '/reports/streaming/' + $scope.entity.id + '/' + c + '/' + n + "?token=" + Auth.getAuthToken();

                    });
                }],
            scope: {
                entity: '=',
                date: '='
            }
        };
    });

}





// WEBPACK FOOTER //
// ./js/actions/rightsStreamingReport.js